import { DomHandler } from 'primeng/dom';

export function patchDomHandlerGetScrollableParents(): void {
  const originalGetScrollableParents = DomHandler.getScrollableParents;

  DomHandler.getScrollableParents = function (element: any): any[] {
    if (!element || !(element instanceof Element)) {
      return [];
    }
    try {
      return originalGetScrollableParents.call(this, element);
    } catch (error) {
      return [];
    }
  };
}
